<template>
  <div>
    <v-subheader
      v-if="isPlanificacio || showOnlyActivities"
      v-text="isPlanificacio ? 'Objectius de la planificació' : 'Exercicis utilitzats'"
    />
    <v-divider v-if="isPlanificacio || showOnlyActivities" class="mb-2" />
    <v-treeview
      v-if="isPlanificacio || showOnlyActivities"
      :items="isPlanificacio ? globalsUsed : resumActivitats"
      item-text="title"
      item-key="id"
      expand-icon="keyboard_arrow_down"
      :open="openAllUsed"
      hoverable
      :class="{ 'small-indent': !isPlanificacio }"
    >
      <template v-slot:label="{ item }">
        <div class="d-flex justify-space-between">
          <treeview-item :item="item" :resumActivitatMetaIds="resumActivitatMetaIds" />
        </div>
      </template>

      <template v-if="!isPlanificacio" v-slot:append="{ item }">
        <v-btn
          v-if="item.meta.objectiu_id"
          icon
          x-small
          @click="$emit('openItemDialogRead', item.meta.id)"
        >
          <v-icon size="16"> settings</v-icon>
        </v-btn>
      </template>

      <template v-if="!isPlanificacio" v-slot:prepend="{ item }">
        <div
          class="mr-2 my-1"
          v-if="item.meta && item.meta.media && item.meta.media.type === 'image'"
        >
          <v-img max-height="100px" max-width="100px" :src="item.meta.media.url" />
        </div>
      </template>
    </v-treeview>

    <v-subheader v-if="isPlanificacio"> Altres objectius </v-subheader>
    <v-divider v-if="isPlanificacio" class="mb-2" />

    <v-treeview
      v-if="!showOnlyActivities"
      :items="isPlanificacio ? globalsNoUsed : globals.items"
      item-text="title"
      item-key="title"
      expand-icon="keyboard_arrow_down"
      :open="openAllNoUsed"
      hoverable
      :class="{ 'small-indent': !isPlanificacio }"
    >
      <template v-slot:label="{ item }">
        <div class="d-flex justify-space-between">
          <treeview-item :item="item" :resumActivitatMetaIds="resumActivitatMetaIds" />
        </div>
      </template>
      <template v-if="!isPlanificacio" v-slot:append="{ item }">
        <v-btn
          v-if="item.meta.objectiu_id"
          icon
          x-small
          @click="$emit('openItemDialogRead', item.meta.id)"
        >
          <v-icon size="16"> settings</v-icon>
        </v-btn>
      </template>
      <template v-if="!isPlanificacio" v-slot:prepend="{ item }">
        <div
          class="mr-2 my-1"
          v-if="item.meta && item.meta.media && item.meta.media.type === 'image'"
        >
          <v-img max-height="100px" max-width="100px" :src="item.meta.media.url" />
        </div>
      </template>
    </v-treeview>
  </div>
</template>

<script>
export default {
  components: {
    TreeviewItem: () => import("./PlanificacioNavTreeviewItem"),
  },
  props: {
    globals: {
      type: Object,
      required: true,
    },
    globalsUsed: {
      type: Array,
      required: true,
    },
    globalsNoUsed: {
      type: Array,
      default: () => null,
    },
    board: {
      type: Array,
      required: true,
    },
    openAllGlobals: {
      type: Boolean,
      required: true,
    },
    isPlanificacio: {
      type: Boolean,
      required: true,
    },
    showOnlyActivities: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {
    resumActivitats() {
      const activities = this.board
        .map(column => column.children.map(item => [item, ...item.children]))
        .flat(2)

      const uniqueActivities = []
      const uniqueIds = []

      for (const i in activities) {
        const activity = { ...activities[i] }
        const isDuplicate = uniqueIds.includes(activity.title)

        if (activity.children.length) activity.children = []

        if (!isDuplicate) {
          uniqueIds.push(activity.title)
          uniqueActivities.push(activity)
        }
      }

      return uniqueActivities.sort(function (a, b) {
        if (a.title > b.title) return 1
        if (a.title < b.title) return -1
        return 0
      })
    },
    resumActivitatMetaIds() {
      return this.board
        .map(column =>
          column.children.map(item => {
            return [item.meta.id, ...item.children.map(subitem => subitem.meta.id)]
          })
        )
        .flat(2)
    },
    openAllUsed() {
      // TODO - Treeview bug. As workaround, treeview key is "title" instead of "id".
      return this.openAllGlobals ? this.globalsUsed.map(item => item.title) : []
    },
    openAllNoUsed() {
      // TODO - Treeview bug. As workaround, treeview key is "title" instead of "id".
      return this.openAllGlobals ? this.globalsNoUsed.map(item => item.title) : []
    },
  },
}
</script>

<style lang="scss">
.v-treeview {
  div {
    white-space: normal;
    cursor: default;

    &.prd-treeview__handle {
      cursor: grab;

      &:hover {
        color: black;
        text-decoration: underline;
      }
    }
  }

  &.small-indent {
    .v-treeview-node {
      &__level {
        width: 3px;
      }

      &__prepend {
        min-width: 0;
        margin: 0;
      }
    }
  }
}
</style>
